import CheckIcon from '@mui/icons-material/Check';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

import { useStoreSelector } from 'v3/data/store';
import { hideSnackbar } from 'v3/data/store/snackbar/actions';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { AlertStyled, SnackBarStyled } from './styles';

export const SnackBar = () => {
  const { error, severity, title } = useStoreSelector((store) => store.snackbar);

  return (
    <SnackBarStyled
      open={error}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={5000}
      transitionDuration={0}
      onClose={() => hideSnackbar()}
    >
      <AlertStyled
        variant="filled"
        iconMapping={{
          error: <ReportProblemIcon fontSize="inherit" />,
          success: <CheckCircleOutlineIcon fontSize="inherit" />,
          warning: <CheckIcon fontSize="inherit" />,
        }}
        severity={severity}
      >
        <SubtitleMedium>{title}</SubtitleMedium>
      </AlertStyled>
    </SnackBarStyled>
  );
};
